<ion-modal
  class="demand-wait-modal"
  [isOpen]="isOpen"
  [backdropDismiss]="false"
  [keepContentsMounted]="true"
>
  <ng-template>
    <div class="demand-wait-overlay">
      <div class="demand-wait-overlay__panel">
        <div class="loading__circles">
          <div class="ellips-1">
            <div class="shape shape-1"></div>
            <div class="shape shape-2"></div>
            <div class="shape shape-3"></div>
            <div class="shape shape-4"></div>
            <div class="shape shape-5"></div>
            <div class="shape shape-6"></div>
            <div class="shape shape-7"></div>
            <div class="shape shape-8"></div>
            <div class="shape shape-9"></div>
            <div class="shape shape-10"></div>
            <div class="shape shape-11"></div>
            <div class="shape shape-12"></div>
            <div class="ellips-2">
              <div class="ellips-3">
                <div class="ellips-4">
                  <div class="ellips-5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="demand-wait-overlay__text">{{ message | translate }}</p>
        <app-button
          *ngIf="showReportButton"
          [typeNumber]="1"
          (onClick)="goToProblemReport()"
          [innerText]="'PROVIDER.SIGNALE_PROBLEM.TITLE' | translate"
        ></app-button>
      </div>
      <div class="demand-wait-overlay__footer">
        <app-particulier-footer></app-particulier-footer>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="showMeetModal" [backdropDismiss]="false" [initialBreakpoint]="1">
  <ng-template>
    <div class="confirm-meeting-modal">
      <app-meeting-demand-modal [data]="meetResource"></app-meeting-demand-modal>
    </div>
  </ng-template>
</ion-modal>
